import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html {
    /* 如果用户调大了浏览器的默认字体大小，则保持一致。 */
    -webkit-text-size-adjust: 100%;
  }

  body {
    margin: 0;
    background-color: ${({ theme }) => theme.color.background};
    color: ${({ theme }) => theme.color.text};
    font-family: ${({ theme }) => theme.font.body};
    line-height: 1.75;
    word-break: normal;
    overflow-wrap: break-word;
  }

  h1, h2, h3, p, figure, blockquote {
    margin: 0;
  }

  /*
   * Safari 在 list-style: none 的列表中会移除 list role。由于本婚礼邀请函
   * 的主要入口是 iOS 内置浏览器，如果删除标记，则“6张照片”或交通工具项目数
   * 等信息将完全消失。
   * 对于清除标记的列表，务必同时添加 role="list"。
   */
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  img, video {
    display: block;
    max-width: 100%;
  }

  button {
    font: inherit;
    color: inherit;
  }

  /*
   * 仅对键盘用户显示聚焦环。
   * 如果删除默认 outline 而不提供替代样式，将无法通过键盘识别当前位置，
   * 因此我们不是直接删除，而是将其改为更清晰的样式。
   */
  :focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
    outline-offset: 2px;
    border-radius: 2px;
  }

  /*
   * 前庭系统障碍的用户在大幅度动作中可能会感到眩晕或恶心。
   * 对于开启了操作系统“减弱动态效果”的用户，几乎移除所有转换动画。
   */
  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
      scroll-behavior: auto !important;
    }
  }
`;
